import { ImpersonationMode } from '../../types/impersonationModes';
import { LinkDescriptor } from './types';

export const byAllowedRoles = (userRoles: string[], linkDescriptor: LinkDescriptor) =>
  linkDescriptor.allowedRoles !== undefined
    ? linkDescriptor.allowedRoles.some((role) => userRoles.includes(role))
    : true;

export const byExcludededRoles = (userRoles: string[], linkDescriptor: LinkDescriptor) =>
  linkDescriptor.excludedRoles !== undefined && linkDescriptor.excludedRoles
    ? linkDescriptor.excludedRoles.every((role) => !userRoles.includes(role))
    : true;

export const byAllowedCountryCodes = (userCountryCode: string, linkDescriptor: LinkDescriptor) =>
  linkDescriptor.allowedCountryCodes !== undefined
    ? linkDescriptor.allowedCountryCodes.some((countryCode) => userCountryCode === countryCode)
    : true;

export const byExcludedCountryCodes = (userCountryCode: string, linkDescriptor: LinkDescriptor) =>
  linkDescriptor.excludedCountryCodes !== undefined && linkDescriptor.excludedCountryCodes.length
    ? linkDescriptor.excludedCountryCodes.every((countryCode) => userCountryCode !== countryCode)
    : true;

export const byAllowedFeatureAssets = (userAsset: string[], linkDescriptor: LinkDescriptor) =>
  linkDescriptor.allowedFeatureAssets !== undefined
    ? linkDescriptor.allowedFeatureAssets.some((asset) => userAsset.includes(asset))
    : true;

export const byRequiredFeatureFlags = (featureFlags: Record<string, boolean>, linkDescriptor: LinkDescriptor) =>
  linkDescriptor.requiredFeatureFlags !== undefined
    ? linkDescriptor.requiredFeatureFlags.every(ff => featureFlags[ff])
    : true;

export const byExcludedByFeaureFlag = (featureFlags: Record<string, boolean>, linkDescriptor: LinkDescriptor) =>
  linkDescriptor.excludedByFeatureFlag !== undefined && linkDescriptor.excludedByFeatureFlag.length
    ? linkDescriptor.excludedByFeatureFlag.every(ff => !featureFlags[ff])
    : true;

export const byAllowedImpesonationModes = (currentModes: ImpersonationMode[], linkDescriptor: LinkDescriptor) =>
  linkDescriptor.allowedImpersonationModes !== undefined
    ? linkDescriptor.allowedImpersonationModes.some((mode) => currentModes.includes(mode))
    : true;

export const byExcludedImpersonationModes = (currentModes: ImpersonationMode[], linkDescriptor: LinkDescriptor) =>
  linkDescriptor.excludedImpersonationModes !== undefined && linkDescriptor.excludedImpersonationModes.length
    ? linkDescriptor.excludedImpersonationModes.every(excludedMode => !currentModes.includes(excludedMode))
    : true;

export const byCanAccess = (linkDescriptor: LinkDescriptor) =>
  linkDescriptor.canAccess !== undefined ? linkDescriptor.canAccess : true;